export const QuestionActionTypes={
    SET_FETCHED_QUESTIONS_TO_STATE_COUCH_POTATO2:'SET_FETCHED_QUESTIONS_TO_STATE_COUCH_POTATO2',
    SET_SELECTED_QUESTION_COUCH_POTATO2:'SET_SELECTED_QUESTION_COUCH_POTATO2',
    SELECTED_QUESTION_NEXT_COUCH_POTATO2:'SELECTED_QUESTION_NEXT_COUCH_POTATO2',
    SELECTED_QUESTION_PREVIOUS_COUCH_POTATO2:'SELECTED_QUESTION_PREVIOUS_COUCH_POTATO2',
    SET_SELECTED_ANSWER_COUCH_POTATO2:'SET_SELECTED_ANSWER_COUCH_POTATO2',
    // SET_RECENT_FETCHED_TIME:"SET_RECENT_FETCHED_TIME"
}